module.exports = __webpack_public_path__ + "img/mu.e7b1ed61.svg";